import React, { useEffect, useRef } from "react"
import { type AnalysisWithCompsType } from "@/queries/analysis"
import { useSafeAreaInsets } from "react-native-safe-area-context"

import { type BottomSheetModal } from "@gorhom/bottom-sheet"
import PropertyInfoDrawer from "@/components/analysis/PropertyInfoDrawer"
import { View } from "react-native"

interface PropertyInfoModalProps {
  analysis: AnalysisWithCompsType
}

export const PropertyInfoModal: React.FC<PropertyInfoModalProps> = ({
  analysis,
}) => {
  const selectedBottomDrawerRef = useRef<BottomSheetModal>(null)
  const insets = useSafeAreaInsets()

  useEffect(() => {
    // Present the BottomSheetModal after the component has mounted
    selectedBottomDrawerRef.current?.present()

    // Return a cleanup function to dismiss the BottomSheetModal
    // before the component is unmounted
    return () => {
      selectedBottomDrawerRef.current?.dismiss()
    }
  }, [])

  return (
    <View
      className={`p-4 overflow-visible shadow w-full bg-midnight-blue`}
      style={{
        height: 135 + insets.bottom / 2,
      }}
    >
      <PropertyInfoDrawer analysis={analysis} />
    </View>
  )
}

export default PropertyInfoModal
